// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  CascadeDirection,
  CascadeTrigger,
  CascadeEffect,
  RgbaColor,
} from "./types";

export default {
  relationshipName: __t.string(),
  triggerDtmi: __t.option(__t.string()),
  get direction() {
    return CascadeDirection;
  },
  get triggers() {
    return __t.array(CascadeTrigger);
  },
  get effect() {
    return CascadeEffect;
  },
  opacity: __t.f32(),
  useOverrideOpacity: __t.bool(),
  get overrideColor() {
    return RgbaColor;
  },
  useOverrideColor: __t.bool(),
  maxDepth: __t.i32(),
};
